import { axiosManagerPageClient } from "service/managerPageFacebookService";

export async function getDepartment() {
  try {
    const response = await axiosManagerPageClient.get(`/checking-departments`);

    return response;
  } catch (error: any) {
    throw error.response?.data;
  }
}
